/**
 * Satisfaction Ratings
 **/
export const Satisfaction_Ratings = function( $ ) {

	const module = {
		elements: {
			$satisfactionRatings: $( '.satisfaction-ratings' ),
			$ratingTrigger: $( '.js--satisfaction-trigger' ),
		},

		showLoading: function() {
			this.elements.$satisfactionRatings.css( {
				'opacity': '0.5',
			} );

			this.elements.$ratingTrigger.each( function() {
				const $trigger = $( this );

				if ( !$trigger.hasClass( 'is-selected' ) ) {
					$trigger.addClass( 'is-disabled' );
				}

				$trigger.prop( 'disabled', true );
			} );
		},

		hideLoading: function() {
			this.elements.$satisfactionRatings.css( {
				'opacity': '1',
			} );

			this.elements.$ratingTrigger.each( function() {
				$( this ).prop( 'disabled', false ).removeClass( 'is-disabled' );
			} );
		},

		rate: function( type, articleId ) {

			// Show the loading.
			module.showLoading();

			$.ajax( {
				url: CFN.ajaxUrl,
				data: {
					action: 'satisfaction_ratings',
					type: type,
					articleId: articleId,
				}
			} ).always( function() {

				// Always hide loading when done.
				module.hideLoading();

			} ).done( function( data ) {

				/**
				 * Handle fail.
				 */
				if ( data.success ) {

				} else {
					console.error( data.error );
				}

			} ).fail( function( jqXHR, textStatus, errorThrown ) {
				console.error( errorThrown );
			} );

		},

		clearButtonSelected: function() {
			this.elements.$ratingTrigger.each( function() {
				$( this ).removeClass( 'is-selected' );
			} );
		},
	};

	/**
	 * Trigger when the user clicks on a rating button.
	 */
	module.elements.$ratingTrigger.click( function( e ) {
		e.preventDefault();

		const $button = $( this );
		const type = $button.data( 'type' );
		const articleId = $button.data( 'article_id' );

		// If we have already rated, don't re-process.
		if ( $button.hasClass( 'is-selected' ) ) {
			return;
		}

		module.clearButtonSelected();

		$button.addClass( 'is-selected' );

		module.rate( type, articleId );

	} );

	return module;

}( jQuery );
